import { render, staticRenderFns } from "./Logotipo.vue?vue&type=template&id=1a688063&"
import script from "./Logotipo.vue?vue&type=script&lang=js&"
export * from "./Logotipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports